let inject = ['$scope', '$uibModalInstance', '$timeout', 'SessionService', 'modalOptions', 'OrdersService'];

class SyncOrderModalController {
  constructor ($scope,$uibModalInstance, $timeout, SessionService, modalOptions, OrdersService) {
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.OrdersService = OrdersService;
    this.SessionService = SessionService;
    this.$uibModalInstance = $uibModalInstance;
    this.modalOptions = modalOptions;
    this.mensajeNotificacion = 'Espere un momento mientras se sincroniza el pedido No. ' + this.modalOptions.orderId;
    this.activate();
  }

  activate(){
    this.syncOrder();
  }

  syncOrder() {
    let orderId = parseInt(this.modalOptions.orderId);
    this.mensajeNotificacion = 'Espere un momento mientras se sincroniza el pedido No. ' + orderId;
    this.tituloMensajeNotificacion = 'Sincronización de Pedidos';
    this.OrdersService.syncOrder(orderId).then(response => {
      this.mensajeNotificacion = response.message;
      if (!response.error) {
        this.$timeout(() => {
          this.ok(response.datos.sincronizado);
        }, 3000);
      } else {
        this.mensajeNotificacion = 'Lo sentimos el pedido no pudo ser sincronizado. Por favor intentelo nuevamente';
      }
    }).catch(reason => {
      this.mensajeNotificacion = 'Lo sentimos el pedido no pudo ser sincronizado. Por favor intentelo nuevamente';
    });
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  ok() {
    this.$uibModalInstance.close();
  }
}

SyncOrderModalController.$inject = inject;

export default SyncOrderModalController;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/orders/sync-order-modal/sync-order-modal.controller.js
 **/